var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.711,
    height: 20.454,
    viewBox: "0 0 18.711 20.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "border_color_FILL0_wght400_GRAD0_opsz48",
    d: "M4,24.729V21.9H22.711v2.83Zm1.918-5.309V16.308l8.724-8.724,3.111,3.111L9.029,19.419Zm1.4-1.4H8.374l7.368-7.368L14.689,9.6,7.321,16.963Zm11.461-8.35L15.671,6.555,17.636,4.59a.794.794,0,0,1,.585-.316.9.9,0,0,1,.655.316L20.7,6.415a.905.905,0,0,1,.3.643.982.982,0,0,1-.257.643ZM7.321,18.016Z",
    transform: "translate(-4 -4.274)",
    fill: "#00aeef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/editBlue.f71adadcd1314ebab01cc92d405059a8.svg";
export { ForwardRef as ReactComponent };